export const LoginIcon = ({ className }: { className: string }) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="currentColor"
        className={className}
    >
        <path d="M14.8531 12.3531C15.0469 12.1594 15.0469 11.8406 14.8531 11.6469L10.8531 7.64687C10.6594 7.45312 10.3406 7.45312 10.1469 7.64687C9.95312 7.84062 9.95312 8.15938 10.1469 8.35313L13.2937 11.5H4.5C4.225 11.5 4 11.725 4 12C4 12.275 4.225 12.5 4.5 12.5H13.2937L10.1469 15.6469C9.95312 15.8406 9.95312 16.1594 10.1469 16.3531C10.3406 16.5469 10.6594 16.5469 10.8531 16.3531L14.8531 12.3531ZM14.5 18C14.225 18 14 18.225 14 18.5C14 18.775 14.225 19 14.5 19H17.5C18.8813 19 20 17.8813 20 16.5V7.5C20 6.11875 18.8813 5 17.5 5H14.5C14.225 5 14 5.225 14 5.5C14 5.775 14.225 6 14.5 6H17.5C18.3281 6 19 6.67188 19 7.5V16.5C19 17.3281 18.3281 18 17.5 18H14.5Z" />
    </svg>
);
